module.exports = __webpack_public_path__ + "static/media/kak2c_logo.59325979.svg";